var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-dropdown" }, [
    _vm.showPlaceholder
      ? _c("div", { staticClass: "c-dropdown__placeholder" }, [
          _vm._v("\n    " + _vm._s(_vm.placeholderText) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "c-dropdown__holder",
        on: {
          click: function($event) {
            return _vm.toggleMenu()
          }
        }
      },
      [
        _c("span", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _c("span", { staticClass: "c-dropdown__caret" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "11",
                height: "13",
                viewBox: "0 0 11 13",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M-2.6227e-07 6.32846C-2.86411e-07 5.77618 0.447715 5.32846 1 5.32846L7.58502 5.32846L4.29291 2.03562C3.93242 1.67513 3.90469 1.10784 4.20972 0.715548L4.29291 0.62131C4.65339 0.26083 5.22062 0.23316 5.61291 0.53818L5.70709 0.62131L10.7071 5.62131C10.7356 5.64978 10.7623 5.68004 10.7872 5.71176L10.7071 5.62131C10.7425 5.65671 10.7747 5.69411 10.8036 5.73313C10.8215 5.75731 10.8383 5.78222 10.8539 5.80783C10.8614 5.81988 10.8685 5.83212 10.8753 5.84445C10.8862 5.86422 10.8966 5.88458 10.9064 5.90537C10.9143 5.92237 10.9218 5.93966 10.9288 5.95712C10.9367 5.97688 10.9439 5.99664 10.9504 6.0167C10.9553 6.03159 10.9599 6.047 10.9642 6.06247C10.9702 6.08402 10.9754 6.1057 10.9799 6.12766C10.9833 6.14507 10.9863 6.16255 10.989 6.18003C10.9921 6.20039 10.9946 6.2214 10.9964 6.24265C10.9979 6.26054 10.9989 6.27792 10.9995 6.29526C10.9998 6.30611 11 6.31724 11 6.32846L10.9995 6.36069C10.9989 6.37871 10.9978 6.39668 10.9963 6.41464L11 6.32846C11 6.37908 10.9962 6.42879 10.989 6.47739C10.9863 6.49438 10.9833 6.5118 10.9797 6.52915C10.9753 6.55117 10.9702 6.57293 10.9643 6.59433C10.9599 6.60995 10.9553 6.62531 10.9503 6.6406C10.9439 6.66026 10.9367 6.68008 10.9289 6.69956C10.9218 6.7173 10.9143 6.73456 10.9063 6.75168C10.8966 6.77235 10.8862 6.79273 10.8751 6.81272C10.8685 6.82483 10.8614 6.83711 10.854 6.84921C10.8383 6.87477 10.8215 6.89965 10.8037 6.92368C10.7993 6.92973 10.7948 6.93555 10.7903 6.94138C10.7623 6.97695 10.7356 7.00715 10.7071 7.03562L5.70709 12.0356C5.31657 12.4261 4.68343 12.4261 4.29291 12.0356C3.93242 11.6751 3.90469 11.1078 4.20972 10.7155L4.29291 10.6213L7.58502 7.32846L1 7.32846C0.447715 7.32846 -2.38129e-07 6.88074 -2.6227e-07 6.32846Z",
                  fill: "#313131"
                }
              })
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _vm.showMenu
      ? _c(
          "ul",
          { staticClass: "c-dropdown__menu" },
          _vm._l(_vm.options, function(option) {
            return _c(
              "li",
              {
                key: option.id,
                on: {
                  click: function($event) {
                    return _vm.updateOption(option)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }